type Props = {
  percentage: string | number | null;
  roundColor?: string | undefined;
  className?: string;
};

/** Band colors when `roundColor` is not passed — keep in sync with `PercentageCircle` logic. */
export function getPercentageCircleDefaultBandHex(
  percentage: string | number | null | undefined,
): string {
  let color = "#FB7185";
  const per = Number(percentage);

  if (percentage) {
    if (per > 0 && per < 25) {
      color = "#FB7185";
    }
    if (per > 25 && per < 50) {
      color = "#FBBF24";
    }
    if (per > 50 && per < 75) {
      color = "#60A5FA";
    }
    if (per > 75 && per <= 100) {
      color = "#34D399";
    }
  }
  return color;
}

function PercentageCircle(props: Props) {
  const { percentage, roundColor, className } = props;
  const per = Number(percentage);
  const color = roundColor
    ? roundColor
    : getPercentageCircleDefaultBandHex(percentage);
  return (
    <>
      <div className="w-full flex justify-center items-center">
        <div
          className={`h-10 w-10 rounded-full text-[11px] flex justify-center items-center ${className}`}
          role="progressbar"
          aria-valuenow={75}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{
            color: color,
            background: `radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(${
              roundColor ? color.trim() : color
            } ${per}%, ${roundColor ? color.trim() + "67" : color.concat('67') } 0)`,
          }}
        >
          <div className="m-1">{per.toFixed()}%</div>
        </div>
      </div>
    </>
  );
}

export default PercentageCircle;
